module.exports = __webpack_public_path__ + "static/tickethoss_logo_without_phone-469bb7fa7410f969d840b47011e1a3fa.svg";